export const CHANGE_SELECTED_ORDER = "CHANGE_SELECTED_ORDER";
export const GET_ORDER_SUCCESS = 'GET_ORDER_SUCCESS';
export const GET_ORDER_ERROR = 'GET_ORDER_ERROR';